import { createContext, createRef, } from 'react';
export const defaultContext = {
    drawerContentRef: createRef(),
};
export const DrawerContext = createContext(defaultContext);
